import React from 'react';
import { manufacturerBrands } from '../../data/modalities';
export function ManufacturerStrip() {
  return <section className="w-full border-y border-slate-200 bg-slate-50" data-id="element-203" data-mp="1ehc30zzhkuqb">
      <div className="mx-auto max-w-7xl px-5 py-8 sm:px-8" data-id="element-204" data-mp="1tdjpk6yda88r">
        <p className="text-center text-[11px] font-semibold uppercase tracking-[0.16em] text-charcoal/55" data-id="element-205" data-mp="1tf4jpvgrrp63">
          Curated technologies from trusted modality brands
        </p>
        <div className="mt-5 flex flex-wrap justify-center gap-2.5" data-id="element-206" data-mp="22d6rquyx7i2v">
          {manufacturerBrands.map(brand => <span key={brand} className="rounded-full border border-slate-200 bg-white px-3.5 py-2 text-xs font-semibold tracking-wide text-navy shadow-sm" data-id="element-207" data-mp="1xf4xrezyhycm">
              {brand}
            </span>)}
        </div>
      </div>
    </section>;
}